import { UseFormRegister, Validate } from "react-hook-form";
import Label from "../Label";
import Hint from "../../fields/Hint";
import useRegisterPropOrFromContext from "./useRegisterPropOrFromContext";
import classNames from "classnames";

type InputArgs = {
  name: string;
  register?: UseFormRegister<any>;
  label?: string;
  hint?: string;
  required?: string | boolean;
  placeholder?: string;
  multiline?: boolean;
  maxLength?: number;
  disabled?: boolean;
  ariaLabel?: string;
  type?: string;
  rows?: number;
  error?: boolean;
  className?: string;
  containerClassName?: string;
  autoFocus?: boolean;
  validate?: Validate<any, any>;
};

export default function TextInput({
  label,
  register,
  name,
  hint,
  placeholder = "",
  required = false,
  multiline = false,
  maxLength,
  disabled = false,
  ariaLabel = label,
  type = "text",
  rows,
  error = false,
  className,
  containerClassName,
  autoFocus = false,
  validate,
}: InputArgs) {
  register = useRegisterPropOrFromContext(register);

  return (
    <div className={classNames("control-group", containerClassName)}>
      {label && <Label label={label} required={!!required} />}
      <div className="controls">
        {multiline ? (
          <textarea
            {...register(name, { required, validate })}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            rows={rows}
            aria-label={ariaLabel}
            autoFocus={autoFocus}
            className={classNames(
              { "field-error field-error-live": error },
              className,
            )}
          />
        ) : (
          <input
            type={type}
            {...register(name, { required, validate })}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            aria-label={ariaLabel}
            autoFocus={autoFocus}
            className={classNames(
              {
                "field-error field-error-live": error,
                "h-11 text-lg": window.isApp,
              },
              className,
            )}
          />
        )}
        {hint && <Hint hint={hint} />}
      </div>
    </div>
  );
}
